import * as React from 'react'
import { GlobalHotKeys } from 'react-hotkeys'

import { Box, Button, Divider } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import './index.styles.css'
interface Props {
  onClick: (amount: number) => void
  isFullyUncollapsed: boolean
  onUncollapseAll: () => void
}

const NO_ZOOM = 0.0
const ZOOM_IN = 1.4
const ZOOM_OUT = 0.6

const ActionBar: React.FC<Props> = ({ onClick, isFullyUncollapsed, onUncollapseAll }) => {
  const handleZoomIn = () => {
    onClick(ZOOM_IN)
  }

  const handleZoomOut = () => {
    onClick(ZOOM_OUT)
  }

  const handleZoomToFit = () => {
    onClick(NO_ZOOM)
  }

  const buttonText = isFullyUncollapsed
    ? i18n.t('employees.orgchart.action_bar.minimize_all')
    : i18n.t('employees.orgchart.action_bar.expand_all')

  return (
    <Box
      className={'ActionBar_actionBar'}
      flexDirection="row"
      paddingY="s16"
      paddingRight="s16"
      paddingLeft="s24"
      gap="s4"
    >
      <Button type="secondary" onClick={handleZoomOut} iconName="remove" />
      <Button type="secondary" onClick={handleZoomToFit}>
        {i18n.t('employees.orgchart.action_bar.zoom_to_fit')}
      </Button>
      <Button type="secondary" onClick={handleZoomIn} iconName="add" />
      <Box paddingLeft="s16"></Box>
      <Divider vertical />
      <Box paddingLeft="s16">
        <Button
          type="secondary"
          onClick={onUncollapseAll}
          iconName={isFullyUncollapsed ? 'collapse' : 'expand'}
        >
          {buttonText}
        </Button>
      </Box>
      <GlobalHotKeys
        keyMap={{ zoomOut: '-', zoomIn: '+' }}
        handlers={{ zoomOut: handleZoomOut, zoomIn: handleZoomIn }}
        allowChanges
      />
    </Box>
  )
}

export default ActionBar
